var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProcess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1551px",
    height: "477px",
    viewBox: "0 0 1551 477",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "process") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-2.0%",
    y: "-12.6%",
    width: "104.1%",
    height: "125.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "process",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    filter: "url(#filter-1)",
    transform: "translate(23.000000, 125.000000)",
    fill: "#FC5759",
    fillOpacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35,
    cy: 119,
    r: 35
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 100,
    cy: 119,
    r: 54
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    cx: 158,
    cy: 119,
    r: 54
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    cx: 218,
    cy: 119,
    r: 54
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    cx: 272,
    cy: 119,
    r: 35
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    cx: 369,
    cy: 119,
    r: 95
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    cx: 464,
    cy: 119,
    r: 35
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    cx: 547,
    cy: 119,
    r: 76
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    cx: 650,
    cy: 119,
    r: 119
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-9",
    cx: 768,
    cy: 119,
    r: 49
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-10",
    cx: 868,
    cy: 119,
    r: 95
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-12",
    cx: 959,
    cy: 119,
    r: 64
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-13",
    cx: 1075,
    cy: 119,
    r: 115
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-14",
    cx: 1218,
    cy: 119,
    r: 65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-17",
    cx: 1372,
    cy: 119,
    r: 98
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-18",
    cx: 1300.5,
    cy: 119.5,
    r: 71.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1377.186,221 L1470.5,221 C1482.92641,221 1493,231.073593 1493,243.5 L1493,244.5 C1493,256.926407 1482.92641,267 1470.5,267 L45.5,267 C33.0735931,267 23,256.926407 23,244.5 L23,243.5 C23,231.073593 33.0735931,221 45.5,221 L1121,221 L1077.5,182.924569 C1094.60411,181.930127 1103.15617,181.432906 1103.15617,181.432906 C1126.51414,132.67352 1176.32463,99 1234,99 C1306.25429,99 1366.16509,151.848795 1377.186,221 Z M1121.30042,221 L1346.69958,221 C1336.04437,168.508473 1289.63603,129 1234,129 C1178.36397,129 1131.95563,168.508473 1121.30042,221 Z",
    id: "Combined-Shape",
    fill: "#FC5759"
  }), /*#__PURE__*/React.createElement("text", {
    id: "RESEARCH",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 144.409668,
    y: 251
  }, "RESEARCH")), /*#__PURE__*/React.createElement("text", {
    id: "DESIGN",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 645.147461,
    y: 251
  }, "DESIGN")), /*#__PURE__*/React.createElement("text", {
    id: "PROTOTYPE",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1048.29346,
    y: 251
  }, "PROTOTYPE")), /*#__PURE__*/React.createElement("text", {
    id: "EVALUATION",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1279.40527,
    y: 251
  }, "EVALUATION")), /*#__PURE__*/React.createElement("text", {
    id: "ITERATION",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1190.09326,
    y: 124
  }, "ITERATION")), /*#__PURE__*/React.createElement("text", {
    id: "Survey",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 62,
    y: 58
  }, "Survey")), /*#__PURE__*/React.createElement("text", {
    id: "Comparative-Analysis",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 185,
    y: 82
  }, "Comparative Analysis")), /*#__PURE__*/React.createElement("text", {
    id: "Interview",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 127,
    y: 442
  }, "Interview")), /*#__PURE__*/React.createElement("text", {
    id: "Persona",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 246,
    y: 410
  }, "Persona")), /*#__PURE__*/React.createElement("text", {
    id: "Brainstorming",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 396,
    y: 442
  }, "Brainstorming")), /*#__PURE__*/React.createElement("text", {
    id: "User-Feedback",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 574,
    y: 425
  }, "User Feedback")), /*#__PURE__*/React.createElement("text", {
    id: "User-Feedback",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 987,
    y: 383
  }, "User Feedback")), /*#__PURE__*/React.createElement("text", {
    id: "Storyboarding",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 491,
    y: 85
  }, "Storyboarding")), /*#__PURE__*/React.createElement("text", {
    id: "Storyboarding",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 299,
    y: 119
  }, "Storyboarding")), /*#__PURE__*/React.createElement("text", {
    id: "Wireframe",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 896,
    y: 113
  }, "Wireframe")), /*#__PURE__*/React.createElement("text", {
    id: "Prototyping",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1101,
    y: 88
  }, "Prototyping")), /*#__PURE__*/React.createElement("text", {
    id: "Expert-Feedback",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1245,
    y: 442
  }, "Expert Feedback")), /*#__PURE__*/React.createElement("text", {
    id: "Heuristic-Evaluation",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1328,
    y: 97
  }, "Heuristic Evaluation")), /*#__PURE__*/React.createElement("text", {
    id: "Idea-Synthesizing",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 677,
    y: 97
  }, "Idea Synthesizing")), /*#__PURE__*/React.createElement("text", {
    id: "Expert-Feedback",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 796,
    y: 398
  }, "Expert Feedback")), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(54.000000, 205.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#FC5759",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#FC5759",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(119.000000, 294.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#FC5759",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#FC5759",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(177.000000, 186.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#FC5759",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#FC5759",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-4",
    transform: "translate(291.000000, 205.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#FC5759",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#FC5759",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-6",
    transform: "translate(669.000000, 121.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#FC5759",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#FC5759",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-9",
    transform: "translate(888.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#FC5759",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#FC5759",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-11",
    transform: "translate(1093.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#FC5759",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#FC5759",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-13",
    transform: "translate(1237.000000, 305.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#FC5759",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#FC5759",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-16",
    transform: "translate(1320.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#FC5759",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#FC5759",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3",
    transform: "translate(237.000000, 294.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#FC5759",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#FC5759",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-5",
    transform: "translate(388.000000, 335.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#FC5759",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#FC5759",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-5",
    transform: "translate(483.000000, 205.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#FC5759",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#FC5759",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-7",
    transform: "translate(566.000000, 316.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#FC5759",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#FC5759",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-8",
    transform: "translate(788.000000, 289.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#FC5759",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#FC5759",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-10",
    transform: "translate(979.000000, 304.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#FC5759",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#FC5759",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.25,204.5 L58.25,48.5",
    id: "Line-5",
    stroke: "#FC5759",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.25,441.5 L123.25,302.5",
    id: "Line-5-Copy",
    stroke: "#FC5759",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.25,409.5 L241.25,302.5",
    id: "Line-5-Copy-3",
    stroke: "#FC5759",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.25,441.5 L392.25,343.5",
    id: "Line-5-Copy-5",
    stroke: "#FC5759",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.25,425.5 L570.25,324.5",
    id: "Line-5-Copy-7",
    stroke: "#FC5759",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.208333,397.5 L792.208333,297.5",
    id: "Line-5-Copy-9",
    stroke: "#FC5759",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.201389,382.5 L983.201389,312.5",
    id: "Line-5-Copy-11",
    stroke: "#FC5759",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.20001,169.5 L1324.20001,87.5",
    id: "Line-5-Copy-17",
    stroke: "#FC5759",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Usability-Testing",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1400,
    y: 427
  }, "Usability Testing")), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-16",
    transform: "translate(1391.000000, 338.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#FC5759",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#FC5759",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1395.2,428.5 L1395.2,346.5",
    id: "Line-5-Copy-17",
    stroke: "#FC5759",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.25,185.5 L181.25,72.5",
    id: "Line-5-Copy-2",
    stroke: "#FC5759",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.208333,204.5 L295.208333,108.5",
    id: "Line-5-Copy-4",
    stroke: "#FC5759",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.25,204.5 L487.25,74.5",
    id: "Line-5-Copy-6",
    stroke: "#FC5759",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.25,120.5 L673.25,87.5",
    id: "Line-5-Copy-8",
    stroke: "#FC5759",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.201389,144.5 L892.201389,102.5",
    id: "Line-5-Copy-10",
    stroke: "#FC5759",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.20004,124.5 L1097.20004,78.5",
    id: "Line-5-Copy-12",
    stroke: "#FC5759",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.20001,444.5 L1241.20001,313.5",
    id: "Line-5-Copy-14",
    stroke: "#FC5759",
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/process.b8d8d4935c3df530b66dbf9a0de84b84.svg";
export { ForwardRef as ReactComponent };